"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.jumpOutAction = jumpOutAction;
exports.moduleViewAction = moduleViewAction;
exports.pageViewAction = pageViewAction;
exports.webClickAction = webClickAction;

var _utils = require("../utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function webClickAction(args) {
  var _args$custom, _args$params;

  const custom = (_args$custom = args === null || args === void 0 ? void 0 : args.custom) !== null && _args$custom !== void 0 ? _args$custom : {}; // 自定义字段

  const params = _objectSpread(_objectSpread(_objectSpread({}, this.appBase), custom), {}, {
    url: (0, _utils.getUrl)(),
    title: (0, _utils.getTitle)(),
    page_name: (0, _utils.getTitle)(),
    event_type: 'webClick',
    // 元素点击
    element_id: args === null || args === void 0 ? void 0 : args.id,
    // 元素ID
    params: (_args$params = args === null || args === void 0 ? void 0 : args.params) !== null && _args$params !== void 0 ? _args$params : {}
  });

  this.finAction(params);
}

function pageViewAction(args) {
  var _args$custom2, _args$id;

  const custom = (_args$custom2 = args === null || args === void 0 ? void 0 : args.custom) !== null && _args$custom2 !== void 0 ? _args$custom2 : {}; // 自定义字段

  const params = _objectSpread(_objectSpread(_objectSpread({}, this.appBase), custom), {}, {
    url: (0, _utils.getUrl)(),
    title: (0, _utils.getTitle)(),
    page_name: (0, _utils.getTitle)(),
    page_id: (_args$id = args === null || args === void 0 ? void 0 : args.id) !== null && _args$id !== void 0 ? _args$id : '',
    element_id: args === null || args === void 0 ? void 0 : args.id,
    // 元素ID
    event_type: 'pageView',
    // 页面访问
    event_action: args === null || args === void 0 ? void 0 : args.action // 进入页面

  });

  let timeOnPage = 0;
  const now = Date.parse(new Date()); // 页面离开时候记录访问时间

  if ((args === null || args === void 0 ? void 0 : args.action) === 'leave') {
    timeOnPage = now - this.jumpTime;
    this.jumpTime = now;
    params.time_on_page = timeOnPage;
    params.event_type = 'pageViewLeave';
    params.element_id = this.element_id;
    this.element_id = '';
  } else {
    this.url = (0, _utils.getUrl)();
    this.element_id = args === null || args === void 0 ? void 0 : args.id;
    params.event_action = 'enter';
  }

  this.finAction(params);
}

function moduleViewAction(args) {
  var _args$custom3, _args$attrs, _args$params2;

  const custom = (_args$custom3 = args === null || args === void 0 ? void 0 : args.custom) !== null && _args$custom3 !== void 0 ? _args$custom3 : {}; // 自定义字段

  const attrs = (_args$attrs = args === null || args === void 0 ? void 0 : args.attrs) !== null && _args$attrs !== void 0 ? _args$attrs : {}; // 自定义字段

  const params = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, this.appBase), custom), attrs), {}, {
    url: (0, _utils.getUrl)(),
    title: (0, _utils.getTitle)(),
    page_name: (0, _utils.getTitle)(),
    event_type: 'moduleView',
    // 模块曝光
    element_id: args === null || args === void 0 ? void 0 : args.id,
    // 元素ID
    module_id: args === null || args === void 0 ? void 0 : args.id,
    // 模块id
    params: (_args$params2 = args === null || args === void 0 ? void 0 : args.params) !== null && _args$params2 !== void 0 ? _args$params2 : {}
  });

  this.finAction(params);
}

function jumpOutAction() {
  const params = _objectSpread(_objectSpread({}, this.appBase), {}, {
    url: (0, _utils.getUrl)(),
    title: (0, _utils.getTitle)(),
    page_name: (0, _utils.getTitle)(),
    event_type: 'jump',
    // 页面切后台
    event_action: 'leave'
  });

  this.finAction(params);
}